
import createIcon from "./createIcon";

export const BoldIcon = createIcon('Bold', (props) => {
  return (
    <svg {...props}>
      <path d="M10.15 7.46C10.93 7.57 11.52 7.84 11.94 8.28C12.37 8.72 12.58 9.28 12.58 9.96C12.58 10.95 12.2 11.72 11.45 12.26C10.7 12.8 9.62 13.06 8.22 13.06L4.72 13.06L4.72 2.24L8.18 2.24C9.42 2.24 10.38 2.48 11.05 2.96C11.72 3.44 12.06 4.13 12.06 5.01C12.06 5.61 11.89 6.11 11.56 6.52C11.23 6.93 10.76 7.21 10.15 7.38L10.15 7.46ZM6.3 3.71L6.3 6.72L8 6.72C8.76 6.72 9.36 6.58 9.78 6.3C10.2 6.02 10.41 5.64 10.41 5.14C10.41 4.68 10.2 4.33 9.78 4.08C9.36 3.84 8.76 3.71 7.99 3.71L6.3 3.71ZM8.03 11.59C8.97 11.59 9.69 11.44 10.19 11.13C10.69 10.82 10.94 10.39 10.94 9.82C10.94 9.29 10.69 8.89 10.19 8.61C9.69 8.33 8.97 8.19 8.04 8.19L6.3 8.19L6.3 11.59L8.03 11.59Z" fill={props.color} fillOpacity="1.000000" fillRule="nonzero" />
    </svg >
  )
});
